<template>
  <div :class="{ 'safety-assistant': safetyAssistant }">
    <h2 class="heading mt-2 mb-2">{{ title }}</h2>
    <p :class="['subheading', 'mt-2', message ? 'mb-4' : 'mb-8']">
      {{ subtitle }}
    </p>
    <div v-if="message" class="mb-5 darkRed--text">{{ message }}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CardHeader',
  props: {
    message: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters({
      safetyAssistant: 'safetyAssistant',
    }),
  },
}
</script>
<style scoped lang="sass">
.heading
  display: flex
  align-items: center
  place-content: center
  font-size: 1.25rem
  font-weight: 700
.subheading
  font-size: 1rem
  font-weight: 400
  color: $darkGrey

.theme--dark
  .heading
    color: var(--v-white-base) !important
  .subheading
    color: rgba(255, 255, 255, 0.7) !important
  .darkRed--text
    color: var(--v-darkRed-base) !important

.safety-assistant
  .heading
    color: $white !important
  .subheading
    color: $textMuted !important
  .darkRed--text
    color: $errorRed !important
</style>
